<section class="agentic-bot-hero section-spacing">
  <div class="agentic-bot-hero__wrapper">
    <div class="agentic-bot-hero__copy">
      <h1 class="agentic-bot-hero__title">
        Unlock the Power of
        <span class="agentic-bot-hero__highlight">
          AI-Led Agentic Bot
          <img
            src="/assets/img/feature-imgs/homepage/ai-power.svg"
            alt=""
            aria-hidden="true"
            class="agentic-bot-hero__title-icon"
          />
        </span>
      </h1>
      <p class="agentic-bot-hero__desc">
        Automate ITSM tasks with AI agents, from ticket creation to incident resolution
      </p>

      <div class="agentic-bot-hero__buttons">
        <a
          [routerLink]="['/registration']"
          [queryParams]="{ type: 'trial', product: 'Infraon ITSM' }"
          class="primary-buttons cta-buttons rounded-l"
        >
          Start Free Trial
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <path
              d="M3.33203 8H12.6654"
              stroke="currentColor"
              stroke-width="1.33333"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M8 3.33203L12.6667 7.9987L8 12.6654"
              stroke="currentColor"
              stroke-width="1.33333"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </a>
        <a
          [routerLink]="['/registration']"
          [queryParams]="{ type: 'demo', product: 'Infraon ITSM' }"
          class="secondary-buttons cta-buttons border rounded-l"
        >
          Book a Demo
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <path
              d="M3.33203 8H12.6654"
              stroke="currentColor"
              stroke-width="1.33333"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M8 3.33203L12.6667 7.9987L8 12.6654"
              stroke="currentColor"
              stroke-width="1.33333"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </a>
      </div>

      <p class="agentic-bot-hero__note">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <path
            d="M13.3346 4L6.0013 11.3333L2.66797 8"
            stroke="#16A34A"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        Start your 14-day free trial. No credit card required!
      </p>
    </div>

    <div class="agentic-bot-hero__media">
      <img
        loading="eager"
        src="/assets/img/feature-imgs/itsm/agentic-bot/agentic-bot-hero.webp"
        alt="Agentic Bot ticket creation preview"
        class="agentic-bot-hero__screenshot"
      />
    </div>
  </div>
</section>

<section class="agentic-bot-workflows">
  <div class="agentic-bot-workflows__ticker" aria-hidden="true">
    <div class="agentic-bot-workflows__ticker-track">
      @for (item of workflowTicker; track item) {
        <span class="agentic-bot-workflows__ticker-item">
          {{ item }}
          <svg
            class="agentic-bot-workflows__ticker-dot"
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M-0.000976562 4.89941C0.513997 4.70345 0.965169 4.51888 1.35254 4.3457C1.73991 4.16797 2.07943 3.98568 2.37109 3.79883C2.66276 3.60742 2.92025 3.40007 3.14355 3.17676C3.36686 2.95345 3.57194 2.69368 3.75879 2.39746C3.94564 2.10124 4.12565 1.75944 4.29883 1.37207C4.47656 0.980143 4.66341 0.522135 4.85938 -0.00195312C5.05534 0.522135 5.23991 0.980143 5.41309 1.37207C5.59082 1.75944 5.77311 2.10124 5.95996 2.39746C6.14681 2.69368 6.34961 2.95345 6.56836 3.17676C6.79167 3.40007 7.04915 3.60742 7.34082 3.79883C7.63704 3.98568 7.97656 4.16797 8.35938 4.3457C8.74674 4.51888 9.19792 4.70345 9.71289 4.89941C9.19792 5.09993 8.74674 5.28678 8.35938 5.45996C7.97656 5.63314 7.63704 5.81543 7.34082 6.00684C7.04915 6.19368 6.79167 6.39876 6.56836 6.62207C6.34961 6.84538 6.14681 7.10514 5.95996 7.40137C5.77311 7.69759 5.59082 8.04167 5.41309 8.43359C5.23991 8.82096 5.05534 9.27669 4.85938 9.80078C4.65885 9.27669 4.47201 8.82096 4.29883 8.43359C4.12565 8.04167 3.94564 7.69759 3.75879 7.40137C3.57194 7.10514 3.36686 6.84538 3.14355 6.62207C2.92025 6.39876 2.66276 6.19368 2.37109 6.00684C2.07943 5.81543 1.73991 5.63314 1.35254 5.45996C0.965169 5.28223 0.513997 5.09538 -0.000976562 4.89941Z"
              fill="#4C89F4"
            />
          </svg>
        </span>
      }
      @for (item of workflowTicker; track item) {
        <span class="agentic-bot-workflows__ticker-item">
          {{ item }}
          <svg
            class="agentic-bot-workflows__ticker-dot"
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M-0.000976562 4.89941C0.513997 4.70345 0.965169 4.51888 1.35254 4.3457C1.73991 4.16797 2.07943 3.98568 2.37109 3.79883C2.66276 3.60742 2.92025 3.40007 3.14355 3.17676C3.36686 2.95345 3.57194 2.69368 3.75879 2.39746C3.94564 2.10124 4.12565 1.75944 4.29883 1.37207C4.47656 0.980143 4.66341 0.522135 4.85938 -0.00195312C5.05534 0.522135 5.23991 0.980143 5.41309 1.37207C5.59082 1.75944 5.77311 2.10124 5.95996 2.39746C6.14681 2.69368 6.34961 2.95345 6.56836 3.17676C6.79167 3.40007 7.04915 3.60742 7.34082 3.79883C7.63704 3.98568 7.97656 4.16797 8.35938 4.3457C8.74674 4.51888 9.19792 4.70345 9.71289 4.89941C9.19792 5.09993 8.74674 5.28678 8.35938 5.45996C7.97656 5.63314 7.63704 5.81543 7.34082 6.00684C7.04915 6.19368 6.79167 6.39876 6.56836 6.62207C6.34961 6.84538 6.14681 7.10514 5.95996 7.40137C5.77311 7.69759 5.59082 8.04167 5.41309 8.43359C5.23991 8.82096 5.05534 9.27669 4.85938 9.80078C4.65885 9.27669 4.47201 8.82096 4.29883 8.43359C4.12565 8.04167 3.94564 7.69759 3.75879 7.40137C3.57194 7.10514 3.36686 6.84538 3.14355 6.62207C2.92025 6.39876 2.66276 6.19368 2.37109 6.00684C2.07943 5.81543 1.73991 5.63314 1.35254 5.45996C0.965169 5.28223 0.513997 5.09538 -0.000976562 4.89941Z"
              fill="#4C89F4"
            />
          </svg>
        </span>
      }
    </div>
  </div>

  <div class="agentic-bot-workflows__wrapper section-spacing">
    <div class="agentic-bot-workflows__intro">
      <div class="agentic-bot-workflows__copy">
        <h2 class="agentic-bot-workflows__title">
          Deploy Autonomous AI Agents Into ITSM Workflows
        </h2>
        <p class="agentic-bot-workflows__desc">
          Infraon ITSM's Agentic Bots bring together autonomous actions with configurable RAG-based
          assistance. Your agents can create and update tickets, classify and prioritize incidents,
          assign tickets, retrieve similar incidents, and answer questions from selected knowledge
          sources.
        </p>
      </div>

      <a
        [routerLink]="['/itsm-tool/features/incident-management-software']"
        class="agentic-bot-workflows__link"
      >
        Go to incident management
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <path
            d="M4.66797 4.66797H11.3346V11.3346"
            stroke="#0B1220"
            stroke-width="1.33333"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M4.66797 11.3346L11.3346 4.66797"
            stroke="#0B1220"
            stroke-width="1.33333"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </a>
    </div>

    <div class="agentic-bot-workflows__media">
      <iframe
        class="agentic-bot-workflows__video"
        src="https://www.youtube-nocookie.com/embed/AKLBUdDJXjk?rel=0"
        title="Infraon ITSM Agentic Bot video"
        loading="lazy"
        allow="
          accelerometer;
          autoplay;
          clipboard-write;
          encrypted-media;
          gyroscope;
          picture-in-picture;
          web-share;
        "
        referrerpolicy="strict-origin-when-cross-origin"
        allowfullscreen
      ></iframe>
    </div>
  </div>
</section>

<section class="agentic-bot-features section-spacing">
  <div class="agentic-bot-features__wrapper">
    <header class="agentic-bot-features__header">
      <h2 class="agentic-bot-features__title">Key Agentic Bot Features</h2>
      <p class="agentic-bot-features__subtitle">
        See how each capability turns service intent into a confident next action.
      </p>
    </header>

    @for (feature of keyFeatures; track feature.title) {
      <div
        class="agentic-bot-features__row"
        [class.agentic-bot-features__row--reverse]="feature.imagePosition === 'left'"
      >
        <div class="agentic-bot-features__copy">
          <div class="agentic-bot-features__meta">
            <span class="agentic-bot-features__icon">
              @switch (feature.icon) {
                @case ('command') {
                  <svg width="38" height="38" viewBox="0 0 38 38" fill="none" aria-hidden="true">
                    <rect width="38" height="38" rx="10" fill="#E6EFFF" />
                    <path
                      d="M13.2783 15.4434C12.7588 15.4434 12.2734 15.3442 11.8223 15.146C11.3779 14.9478 10.9917 14.6812 10.6636 14.3462C10.3354 14.0112 10.0757 13.6216 9.88428 13.1772C9.69971 12.7329 9.60742 12.2646 9.60742 11.7725C9.60742 11.2598 9.70312 10.7812 9.89453 10.3369C10.0859 9.89258 10.3457 9.50635 10.6738 9.17822C11.0088 8.84326 11.3984 8.58008 11.8428 8.38867C12.2939 8.19727 12.7725 8.10156 13.2783 8.10156C13.7773 8.10156 14.249 8.19385 14.6934 8.37842C15.1377 8.56299 15.5273 8.81934 15.8623 9.14746C16.1973 9.47559 16.4604 9.86523 16.6519 10.3164C16.8501 10.7607 16.9492 11.2461 16.9492 11.7725V14.2437H21.0405V11.7725C21.0405 11.2461 21.1362 10.7607 21.3276 10.3164C21.5259 9.86523 21.7925 9.47559 22.1274 9.14746C22.4624 8.81934 22.8521 8.56299 23.2964 8.37842C23.7407 8.19385 24.2124 8.10156 24.7114 8.10156C25.2173 8.10156 25.6924 8.19727 26.1367 8.38867C26.5879 8.58008 26.9775 8.84326 27.3057 9.17822C27.6406 9.50635 27.9038 9.89258 28.0952 10.3369C28.2866 10.7812 28.3823 11.2598 28.3823 11.7725C28.3823 12.2646 28.2866 12.7329 28.0952 13.1772C27.9106 13.6216 27.6543 14.0112 27.3262 14.3462C26.998 14.6812 26.6084 14.9478 26.1572 15.146C25.7129 15.3442 25.231 15.4434 24.7114 15.4434H22.2402V19.5347H24.7114C25.231 19.5347 25.7129 19.6338 26.1572 19.832C26.6084 20.0303 26.998 20.2969 27.3262 20.6318C27.6543 20.9668 27.9106 21.3564 28.0952 21.8008C28.2866 22.2451 28.3823 22.7134 28.3823 23.2056C28.3823 23.7183 28.2866 24.1968 28.0952 24.6411C27.9038 25.0854 27.6406 25.4717 27.3057 25.7998C26.9775 26.1348 26.5879 26.3979 26.1367 26.5894C25.6924 26.7808 25.2173 26.8765 24.7114 26.8765C24.2124 26.8765 23.7407 26.7842 23.2964 26.5996C22.8521 26.415 22.4624 26.1587 22.1274 25.8306C21.7925 25.5024 21.5259 25.1162 21.3276 24.6719C21.1362 24.2207 21.0405 23.7319 21.0405 23.2056V20.7344H16.9492V23.2056C16.9492 23.7319 16.8501 24.2207 16.6519 24.6719C16.4604 25.1162 16.1973 25.5024 15.8623 25.8306C15.5273 26.1587 15.1377 26.415 14.6934 26.5996C14.249 26.7842 13.7773 26.8765 13.2783 26.8765C12.7725 26.8765 12.2939 26.7808 11.8428 26.5894C11.3984 26.3979 11.0088 26.1348 10.6738 25.7998C10.3457 25.4717 10.0859 25.0854 9.89453 24.6411C9.70312 24.1968 9.60742 23.7183 9.60742 23.2056C9.60742 22.7134 9.69971 22.2451 9.88428 21.8008C10.0757 21.3564 10.3354 20.9668 10.6636 20.6318C10.9917 20.2969 11.3779 20.0303 11.8223 19.832C12.2734 19.6338 12.7588 19.5347 13.2783 19.5347H15.7495V15.4434H13.2783ZM15.7495 14.2437V11.7725C15.7495 11.4307 15.6846 11.1094 15.5547 10.8086C15.4316 10.5078 15.2573 10.248 15.0317 10.0293C14.813 9.80371 14.5532 9.62598 14.2524 9.49609C13.9517 9.36621 13.627 9.30127 13.2783 9.30127C12.9365 9.30127 12.6187 9.36621 12.3247 9.49609C12.0308 9.62598 11.771 9.80371 11.5454 10.0293C11.3267 10.248 11.1523 10.5078 11.0225 10.8086C10.8994 11.1094 10.8379 11.4307 10.8379 11.7725C10.8379 12.1211 10.8994 12.4458 11.0225 12.7466C11.1523 13.0474 11.3267 13.3105 11.5454 13.5361C11.771 13.7549 12.0308 13.9292 12.3247 14.0591C12.6187 14.1821 12.9365 14.2437 13.2783 14.2437H15.7495ZM13.2783 20.7344C12.9365 20.7344 12.6187 20.7993 12.3247 20.9292C12.0308 21.0522 11.771 21.2266 11.5454 21.4521C11.3267 21.6709 11.1523 21.9307 11.0225 22.2314C10.8994 22.5322 10.8379 22.8569 10.8379 23.2056C10.8379 23.5474 10.8994 23.8687 11.0225 24.1694C11.1523 24.4702 11.3267 24.7334 11.5454 24.959C11.771 25.1777 12.0308 25.3521 12.3247 25.4819C12.6187 25.6118 12.9365 25.6768 13.2783 25.6768C13.627 25.6768 13.9517 25.6118 14.2524 25.4819C14.5532 25.3521 14.813 25.1777 15.0317 24.959C15.2573 24.7334 15.4316 24.4702 15.5547 24.1694C15.6846 23.8687 15.7495 23.5474 15.7495 23.2056V20.7344H13.2783ZM24.7114 14.2437C25.0464 14.2437 25.3608 14.1821 25.6548 14.0591C25.9556 13.9292 26.2153 13.7549 26.4341 13.5361C26.6597 13.3105 26.834 13.0474 26.957 12.7466C27.0869 12.4458 27.1519 12.1211 27.1519 11.7725C27.1519 11.4307 27.0869 11.1094 26.957 10.8086C26.834 10.5078 26.6597 10.248 26.4341 10.0293C26.2153 9.80371 25.9556 9.62598 25.6548 9.49609C25.3608 9.36621 25.0464 9.30127 24.7114 9.30127C24.3628 9.30127 24.0381 9.36621 23.7373 9.49609C23.4365 9.62598 23.1733 9.80371 22.9478 10.0293C22.729 10.248 22.5547 10.5078 22.4248 10.8086C22.3018 11.1094 22.2402 11.4307 22.2402 11.7725V14.2437H24.7114ZM22.2402 20.7344V23.2056C22.2402 23.5474 22.3018 23.8687 22.4248 24.1694C22.5547 24.4702 22.729 24.7334 22.9478 24.959C23.1733 25.1777 23.4365 25.3521 23.7373 25.4819C24.0381 25.6118 24.3628 25.6768 24.7114 25.6768C25.0464 25.6768 25.3608 25.6118 25.6548 25.4819C25.9556 25.3521 26.2153 25.1777 26.4341 24.959C26.6597 24.7334 26.834 24.4702 26.957 24.1694C27.0869 23.8687 27.1519 23.5474 27.1519 23.2056C27.1519 22.8569 27.0869 22.5322 26.957 22.2314C26.834 21.9307 26.6597 21.6709 26.4341 21.4521C26.2153 21.2266 25.9556 21.0522 25.6548 20.9292C25.3608 20.7993 25.0464 20.7344 24.7114 20.7344H22.2402ZM21.0405 15.4434H16.9492V19.5347H21.0405V15.4434Z"
                      fill="#1769EE"
                    />
                  </svg>
                }
                @case ('sparkle') {
                  <svg width="38" height="38" viewBox="0 0 38 38" fill="none" aria-hidden="true">
                    <rect width="38" height="38" rx="10" fill="#E1F8EC" />
                    <path
                      d="M11.7095 19.6479C12.4819 19.354 13.1587 19.0771 13.7397 18.8174C14.3208 18.5508 14.8301 18.2773 15.2676 17.9971C15.7051 17.71 16.0913 17.3989 16.4263 17.064C16.7612 16.729 17.0688 16.3394 17.3491 15.895C17.6294 15.4507 17.8994 14.938 18.1592 14.3569C18.4258 13.769 18.7061 13.082 19 12.2959C19.2939 13.082 19.5708 13.769 19.8306 14.3569C20.0972 14.938 20.3706 15.4507 20.6509 15.895C20.9312 16.3394 21.2354 16.729 21.5635 17.064C21.8984 17.3989 22.2847 17.71 22.7222 17.9971C23.1665 18.2773 23.6758 18.5508 24.25 18.8174C24.8311 19.0771 25.5078 19.354 26.2803 19.6479C25.5078 19.9487 24.8311 20.229 24.25 20.4888C23.6758 20.7485 23.1665 21.022 22.7222 21.3091C22.2847 21.5894 21.8984 21.897 21.5635 22.2319C21.2354 22.5669 20.9312 22.9565 20.6509 23.4009C20.3706 23.8452 20.0972 24.3613 19.8306 24.9492C19.5708 25.5303 19.2939 26.2139 19 27C18.6992 26.2139 18.4189 25.5303 18.1592 24.9492C17.8994 24.3613 17.6294 23.8452 17.3491 23.4009C17.0688 22.9565 16.7612 22.5669 16.4263 22.2319C16.0913 21.897 15.7051 21.5894 15.2676 21.3091C14.8301 21.022 14.3208 20.7485 13.7397 20.4888C13.1587 20.2222 12.4819 19.9419 11.7095 19.6479Z"
                      fill="#16A970"
                    />
                  </svg>
                }
                @case ('flower') {
                  <svg width="38" height="38" viewBox="0 0 38 38" fill="none" aria-hidden="true">
                    <rect width="38" height="38" rx="10" fill="#FFF0E5" />
                    <path
                      d="M18.9897 17.0532C18.73 17.0532 18.5044 16.9609 18.313 16.7764C18.1284 16.5918 18.0361 16.3491 18.0361 16.0483C18.0361 15.7476 18.1284 15.5049 18.313 15.3203C18.4976 15.1289 18.7231 15.0332 18.9897 15.0332C19.2563 15.0332 19.4819 15.1289 19.6665 15.3203C19.8511 15.5049 19.9434 15.7476 19.9434 16.0483C19.9434 16.3491 19.8477 16.5918 19.6562 16.7764C19.4717 16.9609 19.2495 17.0532 18.9897 17.0532ZM22.5786 19.022C22.3188 19.022 22.0933 18.9297 21.9019 18.7451C21.7173 18.5605 21.625 18.3179 21.625 18.0171C21.625 17.7163 21.7173 17.4736 21.9019 17.2891C22.0864 17.0977 22.312 17.002 22.5786 17.002C22.8452 17.002 23.0708 17.0977 23.2554 17.2891C23.4399 17.4736 23.5322 17.7163 23.5322 18.0171C23.5322 18.3179 23.4365 18.5605 23.2451 18.7451C23.0605 18.9297 22.8384 19.022 22.5786 19.022ZM15.4009 19.022C15.1411 19.022 14.9155 18.9297 14.7241 18.7451C14.5396 18.5605 14.4473 18.3179 14.4473 18.0171C14.4473 17.7163 14.5396 17.4736 14.7241 17.2891C14.9087 17.0977 15.1343 17.002 15.4009 17.002C15.6675 17.002 15.8931 17.0977 16.0776 17.2891C16.2622 17.4736 16.3545 17.7163 16.3545 18.0171C16.3545 18.3179 16.2588 18.5605 16.0674 18.7451C15.8828 18.9297 15.6606 19.022 15.4009 19.022ZM22.5786 23.1851C22.3188 23.1851 22.0933 23.0928 21.9019 22.9082C21.7173 22.7236 21.625 22.481 21.625 22.1802C21.625 21.8794 21.7173 21.6367 21.9019 21.4521C22.0864 21.2607 22.312 21.165 22.5786 21.165C22.8452 21.165 23.0708 21.2607 23.2554 21.4521C23.4399 21.6367 23.5322 21.8794 23.5322 22.1802C23.5322 22.481 23.4365 22.7236 23.2451 22.9082C23.0605 23.0928 22.8384 23.1851 22.5786 23.1851ZM15.4009 23.1851C15.1411 23.1851 14.9155 23.0928 14.7241 22.9082C14.5396 22.7236 14.4473 22.481 14.4473 22.1802C14.4473 21.8794 14.5396 21.6367 14.7241 21.4521C14.9087 21.2607 15.1343 21.165 15.4009 21.165C15.6675 21.165 15.8931 21.2607 16.0776 21.4521C16.2622 21.6367 16.3545 21.8794 16.3545 22.1802C16.3545 22.481 16.2588 22.7236 16.0674 22.9082C15.8828 23.0928 15.6606 23.1851 15.4009 23.1851ZM18.9897 25.1641C18.7231 25.1641 18.4976 25.0718 18.313 24.8872C18.1284 24.6958 18.0361 24.4497 18.0361 24.1489C18.0361 23.855 18.1284 23.6157 18.313 23.4312C18.5044 23.2397 18.73 23.144 18.9897 23.144C19.2495 23.144 19.4717 23.2397 19.6562 23.4312C19.8477 23.6157 19.9434 23.855 19.9434 24.1489C19.9434 24.4497 19.8511 24.6958 19.6665 24.8872C19.4819 25.0718 19.2563 25.1641 18.9897 25.1641Z"
                      fill="#DD783C"
                    />
                  </svg>
                }
                @case ('clock') {
                  <svg width="38" height="38" viewBox="0 0 38 38" fill="none" aria-hidden="true">
                    <rect width="38" height="38" rx="10" fill="#EEE9FF" />
                    <path
                      d="M11.6172 17.8735C11.6172 17.2036 11.7026 16.5542 11.8735 15.9253C12.0513 15.2896 12.2974 14.6982 12.6118 14.1514C12.9331 13.6045 13.3159 13.1089 13.7603 12.6646C14.2114 12.2134 14.7104 11.8271 15.2573 11.5059C15.8042 11.1846 16.3921 10.9385 17.021 10.7676C17.6567 10.5898 18.313 10.501 18.9897 10.501C19.6665 10.501 20.3193 10.5898 20.9482 10.7676C21.5771 10.9385 22.165 11.1846 22.7119 11.5059C23.2588 11.8271 23.7578 12.2134 24.209 12.6646C24.6602 13.1089 25.0464 13.6045 25.3677 14.1514C25.689 14.6982 25.9351 15.2896 26.106 15.9253C26.2837 16.5542 26.3726 17.2036 26.3726 17.8735C26.3726 18.5571 26.2837 19.2134 26.106 19.8423C25.9351 20.4712 25.689 21.0591 25.3677 21.606C25.0464 22.1528 24.6602 22.6519 24.209 23.103C23.7578 23.5474 23.2588 23.9302 22.7119 24.2515C22.165 24.5659 21.5771 24.812 20.9482 24.9897C20.3193 25.1606 19.6665 25.2461 18.9897 25.2461C18.3062 25.2461 17.6499 25.1606 17.021 24.9897C16.3921 24.812 15.8042 24.5659 15.2573 24.2515C14.7104 23.9302 14.2114 23.5474 13.7603 23.103C13.3159 22.6519 12.9331 22.1528 12.6118 21.606C12.2974 21.0591 12.0513 20.4712 11.8735 19.8423C11.7026 19.2065 11.6172 18.5503 11.6172 17.8735ZM12.8477 17.8735C12.8477 18.728 13.0083 19.5278 13.3296 20.2729C13.6509 21.0181 14.0884 21.6675 14.6421 22.2212C15.1958 22.7749 15.8452 23.2124 16.5903 23.5337C17.3354 23.855 18.1353 24.0156 18.9897 24.0156C19.7827 24.0156 20.5347 23.8755 21.2456 23.5952C21.9565 23.3081 22.5854 22.915 23.1323 22.416C23.6792 21.917 24.1235 21.3325 24.4653 20.6626C24.814 19.9858 25.0293 19.2612 25.1113 18.4888H18.3745V11.7622C17.6021 11.8442 16.8774 12.0562 16.2007 12.3979C15.5308 12.7397 14.9463 13.1875 14.4473 13.7412C13.9482 14.2881 13.5552 14.917 13.2681 15.6279C12.9878 16.332 12.8477 17.0806 12.8477 17.8735ZM25.1113 17.248C25.0361 16.5303 24.8413 15.8535 24.5269 15.2178C24.2192 14.582 23.8228 14.0215 23.3374 13.5361C22.8521 13.0508 22.2881 12.6543 21.6455 12.3467C21.0098 12.0322 20.333 11.8374 19.6152 11.7622V17.248H25.1113Z"
                      fill="#8260E7"
                    />
                  </svg>
                }
              }
            </span>
            <span class="agentic-bot-features__badge">{{ feature.badge }}</span>
          </div>
          <h3 class="agentic-bot-features__row-title">{{ feature.title }}</h3>
          <p class="agentic-bot-features__row-desc">{{ feature.description }}</p>
        </div>

        <div class="agentic-bot-features__media">
          <img
            loading="lazy"
            [src]="feature.image"
            [alt]="feature.imageAlt"
            class="agentic-bot-features__screenshot"
          />
        </div>
      </div>
    }
  </div>
</section>

<app-agentic-bot-demo></app-agentic-bot-demo>

<section class="agentic-bot-grid-section section-spacing">
  <div class="agentic-bot-grid-section__wrapper">
    <div class="agentic-bot-grid-section__group">
      <h2 class="agentic-bot-grid-section__title">Other ITSM Features</h2>

      <div class="agentic-bot-grid-section__grid agentic-bot-grid-section__grid--four">
        @for (item of otherItsmFeatures; track item.title) {
          <a [routerLink]="item.link" class="agentic-bot-grid-section__cell">
            <span class="agentic-bot-grid-section__number">{{ item.number }}</span>
            <p class="agentic-bot-grid-section__label">{{ item.title }}</p>
            <svg
              class="agentic-bot-grid-section__cell-arrow"
              width="14"
              height="14"
              viewBox="0 0 16 16"
              fill="none"
              aria-hidden="true"
            >
              <path
                d="M4.66797 4.66797H11.3346V11.3346"
                stroke="currentColor"
                stroke-width="1.33333"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M4.66797 11.3346L11.3346 4.66797"
                stroke="currentColor"
                stroke-width="1.33333"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </a>
        }
      </div>

      <a [routerLink]="['/itsm-tool']" class="agentic-bot-grid-section__explore">
        Explore Infraon ITSM
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <path
            d="M3.33203 8H12.6654"
            stroke="currentColor"
            stroke-width="1.33333"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8 3.33203L12.6667 7.9987L8 12.6654"
            stroke="currentColor"
            stroke-width="1.33333"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </a>
    </div>
  </div>
</section>

<app-modern-cta
  badgeLabel="AI-Powered ITSM Automation"
  heading="Ready to automate ITSM with AI-based Agentic Bots?"
  description="No credit card required!"
  secondaryLabel="Start free trial"
  secondaryLink="/registration"
  bottomGlow="rgba(255, 147, 44, 0.12)"
></app-modern-cta>
